<div class="container">
  <div class="head">
    <div class="head-label" mat-dialog-title>
      {{ title }}
    </div>
    <mat-icon class="head-exit" mat-dialog-close="">close</mat-icon>
  </div>

  <div class="content">
    <div *ngFor="let group of groups">
      <div class="selectable-group">
        <mat-checkbox (change)="handleCheckGroup(group, $event.checked)"
                      [checked]="isChecked(group)">
          {{ group.name }}
        </mat-checkbox>
      </div>
    </div>
  </div>
  <button (click)="save()"
          class="submit-button"
          color="primary"
          mat-raised-button>{{ 'COMMON.SAVE' | translate }}</button>
</div>
